import { AlertBlock as AlertBlockType, BlockAction } from '../../types/panel'
import BlockActions from './BlockActions'

interface Props { block: AlertBlockType; onAction?: (action: BlockAction) => void }

export default function AlertBlock({ block, onAction }: Props) {
  return (
    <div className="k-block">
      <div className={'k-alert k-alert--' + block.tone}>
        <div className="k-alert__title">{block.title}</div>
        <div className="k-alert__msg">{block.message}</div>
        <BlockActions actions={block.actions} onAction={onAction} />
      </div>
    </div>
  )
}
